import { compareStrings, nullSafeGet, nullSafeGetOrElse } from './DataAccessUtils';
import { getContactName } from './DataFormatterUtils';
import { getContractorOrWorkOrderId } from './WorkOrderUtils';

export const WEB_SOCKET_FEATURE_FLAG = 'web_socket_features_enabled';

export const WEB_SOCKET_MESSAGE_TYPES = {
	NEW_WO_NOTE: 'new_wo_note',
	WO_NOTE_TYPING: 'wo_note_typing',
	WO_NOTE_TYPING_STOP: 'wo_note_typing_stop',
};

const getMessageSendToForWO = (workOrder, currentUser) =>
	[
		...nullSafeGetOrElse('buyerSubscribers', workOrder, []),
		...nullSafeGetOrElse('supplierSubscribers', workOrder, []),
	]
		.filter((_) => !compareStrings(_.email, currentUser.email))
		.map((_) => ({
			email: _.email,
			contactType: _.contactType,
		}));

export const getTypingPayload = (workOrder, currentUser, messageType) => {
	const payload = {
		messageType,
		workOrderId: getContractorOrWorkOrderId(workOrder),
		data: {
			typingBy: {
				email: currentUser.email,
				nameGiven: nullSafeGet('nameGiven', currentUser),
				nameFamily: nullSafeGet('nameFamily', currentUser),
				contactType: nullSafeGet('contactType', currentUser),
			},
		},
	};

	const sendTo = getMessageSendToForWO(workOrder, currentUser);

	return {
		payload,
		sendTo,
	};
};

export const getNewNotePayload = (workOrder, currentUser) => {
	const payload = {
		messageType: WEB_SOCKET_MESSAGE_TYPES.NEW_WO_NOTE,
		workOrderId: getContractorOrWorkOrderId(workOrder),
	};

	const sendTo = getMessageSendToForWO(workOrder, currentUser);

	return {
		payload,
		sendTo,
	};
};

export const getUpdatedTypingDetails = (typingDetails = [], newDetail, timeoutMs = 8000) => {
	const now = Date.now();

	const updated = (() => {
		//Just invoking to clear stale data
		if (!newDetail) {
			return typingDetails;
		}

		const existingIndex = typingDetails.findIndex((item) =>
			compareStrings(item.email, newDetail.email)
		);

		if (existingIndex !== -1) {
			return typingDetails.map((item) =>
				item.email === newDetail.email ? { ...item, ...newDetail, lastUpdated: now } : item
			);
		}

		return [...typingDetails, { ...newDetail, lastUpdated: now }];
	})();

	return updated.filter((item) => now - item.lastUpdated <= timeoutMs);
};

export const getTypingDetailsText = (typingDetails = []) => {
	const conjunction = typingDetails.length > 1 ? 'are' : 'is';
	return typingDetails.length > 0
		? `${typingDetails.map((_) => getContactName(_)).join(', ')} ${conjunction} typing...`
		: null;
};

export const notify = () => {
	const audio = new Audio('/sounds/chime.mp3');
	audio.play();
};
